// error routes
export default [
    {
        path: "",
        component: () => import('@/layouts/extranetLayout.vue'),
        children: [
            // { path: "acesso-antecipado",  name: "Acesso Antecipado",  component: () => import('@/views/landingPage/LandingView.vue')     },
            { path: "midias", name: "Mídias", component: () => import('@/views/MidiasView.vue') },
            { path: "feedback-compra", name: "Feedback Compras", component: () => import('@/views/FeedBackCompraView.vue') },
            { path: "challenge1", name: "Challenge1", component: () => import('@/views/challenges/Challenge1View.vue') },
            { path: "challenge2", name: "Challenge2", component: () => import('@/views/challenges/Challenge2View.vue') },
            { path: "challenge3", name: "Challenge3", component: () => import('@/views/challenges/Challenge3View.vue') },
            { path: "matricula", name: "Matricula", component: () => import('@/views/extranet/ValidarMatricula.vue') },
            { path: "cartao",     name: "CartaoView", component: () => import('@/views/Card/CartaoView.vue'),  meta: { isComercial: false } },  
            { path: "cartao-comercial",     name: "Cartao Comercial", component: () => import('@/views/Card/CartaoView.vue'), meta: { isComercial: true } },  
            { path: "blog",                    name: "Blog Posts",             component: () => import('@/views/blog/BlogPosts.vue')     },
            { path: "blog-post/:id",                    name: "Post Blog",                 component: () => import('@/views/blog/PostBlog.vue'), props: true },
            
            { path: "faq", name: "FAQ", component: () => import('@/views/LandingPageView.vue'), meta: { scrollTo: "faq" } },
            { path: "building", name: "Building", component: () => import('@/views/LandingPageView.vue'), meta: { scrollTo: "building", showPrices: true } },
            { path: "microcertificacao1", name: "Micro 1", component: () => import('@/views/LandingPageView.vue'), meta: { scrollTo: "microcertificacao1" } },
            { path: "microcertificacao2", name: "Micro 2", component: () => import('@/views/LandingPageView.vue'), meta: { scrollTo: "microcertificacao2" } },
            { path: "microcertificacao3", name: "Micro 3", component: () => import('@/views/LandingPageView.vue'), meta: { scrollTo: "microcertificacao3" } },
            { path: "microcertificacao4", name: "Micro 4", component: () => import('@/views/LandingPageView.vue'), meta: { scrollTo: "microcertificacao4" } },





        ],
    },
    {
        path: "",
        component: () => import('@/views/blog/BlogNavbar.vue'),
        children: [
            { path: "blog",                    name: "Blog Posts",             component: () => import('@/views/blog/BlogPosts.vue')     },
            { path: "blog/:slug",                    name: "Post Blog",                 component: () => import('@/views/blog/PostBlog.vue'), props: true },
        ],
    },
]
